<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="title"
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <div class="flex flex-col gap-[8px] pb-[12px]">
        <div v-if="props.description">{{ props.description }}</div>
        <div class="self-stretch">
          <refonte-item-file-participant-pif
            v-bind:id="`pif-1`"
            title="PIF"
            v-bind:subtitle="pif.subtitle"
            v-bind:on_click_download="props.on_click_download"
            v-bind:pif="pif"
            v-bind:formation_title="pif.produitTitre" />
        </div>
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import { PifDocument } from '@/types/gestion/inscriptions-types';
  import RefonteItemFileParticipantPif from '@/components/refonte/items/refonte-item-file-participant-pif.vue';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      title?: string;
      pif: PifDocument;
      on_click_download?: Function;
      class?: string;
      description?: string;
    }>(),
    {
      title: 'Protocole(s) individuel(s) de formation',
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
